"use client"
import { ConfigProvider } from "antd"
import ptBR from "antd/lib/locale/pt_BR"
import { ThemeProvider } from "styled-components"

import GlobalStyles from "@/styles/globalStyles"
import { defaultThemeColors } from "@/styles/defaultTheme"
import { GlobalProvider } from "@/contexts/useGlobal"

export default function RootLayout({ children }) {
  return (
    <html lang="pt-br">
      <body>
        <ConfigProvider
          locale={ptBR}
          theme={{
            token: {
              colorPrimary: defaultThemeColors.primary,
              colorLink: defaultThemeColors.primary,
              colorLinkHover: defaultThemeColors.primary,
              colorInfo: defaultThemeColors.primary,
              colorBg: defaultThemeColors.background,
              colorPrimaryActive: defaultThemeColors.primary,
              itemActiveBg: defaultThemeColors.background,
              borderRadius: 4,
            },
            components: {
              Modal: {
                wireframe: true,
                contentBg: defaultThemeColors.background,
              }
            },

          }}
        >
          <ThemeProvider theme={defaultThemeColors}>
            <GlobalProvider>{children}</GlobalProvider>
            <GlobalStyles />
          </ThemeProvider>
        </ConfigProvider>
      </body>
    </html>
  )
}
